module.exports = __webpack_public_path__ + "static/media/pic-ausstellung-wissen-in-bildern.3d0b815a.jpg";